// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AGkV","colBig":"styles_colBig__3D4MX","colSmall":"styles_colSmall__3xiCT"};